import { render } from "./ChinaLunLiPage.vue?vue&type=template&id=6dc2b168&scoped=true"
import script from "./ChinaLunLiPage.vue?vue&type=script&lang=js"
export * from "./ChinaLunLiPage.vue?vue&type=script&lang=js"

import "./ChinaLunLiPage.vue?vue&type=style&index=0&id=6dc2b168&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc2b168"]])

export default __exports__